import React, { useState, useEffect, useRef } from "react";

import "./DeepDrive.css";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import Dashboard from "../Dashboard/Dashboard";
import dw from "../../images/file.png";
import deep from "../../images/asm-banner.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function DeepDrive({ globaltest }) {
  const [activeTab, setActiveTab] = useState("N");
  const [deepdiveData, setDeepdiveData] = useState([]);
  const [answers, setAnswers] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const tabs = ["N", "A", "C", "H", "O"];
  const [hasAnswers, setHasAnswers] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showReviewMessage, setShowReviewMessage] = useState(false);
  const deepFluidRef = useRef(null);
  const [BannerContent, setBannerContent] = useState({});

  const [attemptedNextOrSubmit, setAttemptedNextOrSubmit] = useState(false);

  const [loadingBanner, setLoadingBanner] = useState(true);

  const [BannerImage, setBannerImage] = useState(null);

  const textareaRefs = useRef({});

  const currentTabIndex = tabs.indexOf(activeTab);

  const handleNextClick = () => {
    if (!isCurrentTabValid()) {
      console.log(
        "isCurrentTabValid() is false, setting attemptedNextOrSubmit"
      );
      setAttemptedNextOrSubmit(true);
      return;
    }
    setAttemptedNextOrSubmit(false);
    if (currentTabIndex < tabs.length - 1) {
      setActiveTab(tabs[currentTabIndex + 1]);
      setTimeout(() => {
        if (deepFluidRef.current) {
          deepFluidRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  const handlePrevClick = () => {
    if (currentTabIndex > 0) {
      setActiveTab(tabs[currentTabIndex - 1]);

      setTimeout(() => {
        if (deepFluidRef.current) {
          deepFluidRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  useEffect(() => {

        const fetchBanner = async () => {

            setLoadingBanner(true);
            try {
              const [res] = await Promise.all([
                axios.get(`${END_URL}/deep_banner`),
              ]);

              const BannerData = res.data.image1;

              setBannerImage(BannerData);

            } catch (err) {
            
            } finally {

              setLoadingBanner(false);

            }
          };

        fetchBanner();

    }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("User not authenticated");
        return;
      }
      try {
        // Fetch deepdive questions
        const questionsResponse = await axios.get(`${END_URL}/deepdive`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDeepdiveData(questionsResponse.data.data);

        // Don't load previous answers - keep form empty for fresh attempts
        const mappedAnswers = {};
        questionsResponse.data.data.forEach((ans) => {
          mappedAnswers[ans.id] = "";
        });

        setHasAnswers(false);
        setAnswers(mappedAnswers);

        setBannerContent(questionsResponse.data.banner_content);

        setTimeout(() => {
          Object.values(textareaRefs.current).forEach(resizeTextarea);
        }, 0);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();

    // fetchPdfUrl();
    window.scrollTo(0, 0);
    const reviewFlag = localStorage.getItem("showReviewMessage");
    if (reviewFlag === "true") {
      setShowReviewMessage(true);
    }
  }, []);

  const getTabLabel = (tab) => {
    const labels = {
      N: "Natural Gifts",
      A: "Areas to Improve",
      C: "Chances",
      H: "Hurdles",
      O: "Outcomes",
    };
    const count = deepdiveData.filter((item) => item.Type === tab).length;
    return `${labels[tab]} (${count})`;
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setTimeout(() => {
      Object.values(textareaRefs.current).forEach(resizeTextarea);
    }, 0);
  };

  const handleAnswerChange = (id, value) => {
    setAnswers((prev) => ({
      ...prev,
      [id]: value,
    }));

    const textarea = textareaRefs.current[id];
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleSubmit = async () => {
    if (!isAllTabsValid()) {
      setAttemptedNextOrSubmit(true);
      return;
    }
    setAttemptedNextOrSubmit(false);
    const token = localStorage.getItem("token");
    console.log("Current token:", token);
    if (!token) {
      alert("Authentication required");
      return;
    }
    try {
      const payload = {
        answers: deepdiveData.map((item) => ({
          deepdive_id: item.id,
          type: item.Type,
          questions: item.questions,
          answer: answers[item.id] || "",
        })),
      };

      await axios.post(`${END_URL}/user-answers`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // await fetchPdfUrl();

      setShowSuccessModal(true);
      setShowReviewMessage(true);
      localStorage.setItem("showReviewMessage", "true");
    } catch (error) {
      console.error("Submission failed:", error);
      alert("Error saving answers");
    }
  };

  const isCurrentTabValid = () => {
    const currentTabQuestions = deepdiveData.filter(
      (item) => item.Type === activeTab
    );
    return currentTabQuestions.every((q) => {
      const answer = answers[q.id];
      return typeof answer === "string" && answer.trim() !== "";
    });
  };

  const isPreviousTabsValid = (tab) => {
    const tabIndex = tabs.indexOf(tab);
    for (let i = 0; i < tabIndex; i++) {
      const currentTab = tabs[i];
      const currentTabQuestions = deepdiveData.filter(
        (item) => item.Type === currentTab
      );
      const allAnswered = currentTabQuestions.every((q) => {
        const answer = answers[q.id];
        return typeof answer === "string" && answer.trim() !== "";
      });
      if (!allAnswered) return false;
    }
    return true;
  };

  const isAllTabsValid = () => {
    return tabs.every((tab) => {
      const tabQuestions = deepdiveData.filter((item) => item.Type === tab);
      return tabQuestions.every((q) => {
        const answer = answers[q.id];
        return typeof answer === "string" && answer.trim() !== "";
      });
    });
  };

  const resizeTextarea = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const filteredData = deepdiveData.filter((item) => item.Type === activeTab);

  return (
    <div className="deep-main">
      <div className="container-fluid">
        <div className="row ques-row">
          <div className="col-12 col-sm-12 col-md-12">
            <div
              className={`ques-top ${loadingBanner ? 'load-banner' : ''}`}
              style={{
                background: `url(${BannerImage}) no-repeat center center`,
                backgroundSize: "cover",
              }}
            >
              <div
                className="ques-top-title"
                dangerouslySetInnerHTML={{
                  __html: BannerContent?.banner_content_32,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid deep-fluid" ref={deepFluidRef}>

        {/* {pdfUrl && (
          <div className="deep-down">
            <button onClick={handleDownloadPdf}>
              Download Result
              <span>
                <img src={dw} alt="" />{" "}
              </span>
            </button>
          </div>
        )} */}

        <div className="row deep-pop">
          <div className="col-md-8">
            {pdfUrl && (
              <div
                className="alert alert-info"
                dangerouslySetInnerHTML={{
                  __html: BannerContent?.deep_drive_submit_message,
                }}
                style={{ marginBottom: "20px" }}
              />
            )}
          </div>
        </div>

        <div className="row deep-sec-row">
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
            <Dashboard globaltest={globaltest} />
          </div>

          <div className="col-12 col-sm-12 col-md-8 deep-tab">
            <div className="deep-inner-outer">
              <div className="deep-tab-lists">
                <ul>
                  {["N", "A", "C", "H", "O"].map((tab) => (
                    <li
                      key={tab}
                      onClick={() =>
                        isPreviousTabsValid(tab) && handleTabClick(tab)
                      }
                      className={`
                          ${activeTab === tab ? "active" : ""}
                          ${!isPreviousTabsValid(tab) ? "disabled" : ""}
                        `}
                    >
                      <span>{tab}</span>
                      <span>{getTabLabel(tab)}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="deep-contents">
                {filteredData.map((item, index) => (
                  <div key={item.id} className="deep-ip-divs">
                    <label
                      dangerouslySetInnerHTML={{ __html: item.questions }}
                    />
                    <textarea
                      className="deep-ip-divs-textarea"
                      value={answers[item.id] || ""}
                      onChange={(e) =>
                        handleAnswerChange(item.id, e.target.value)
                      }
                      ref={(el) => (textareaRefs.current[item.id] = el)}
                      placeholder="Enter your answer here..."
                    />
                  </div>
                ))}
              </div>

              <div className="ques-btn">
                <div
                  className={`nav-head-out-btn11 ${
                    currentTabIndex > 0 ? "combine-btns-q" : ""
                  }`}
                >
                  {currentTabIndex > 0 && (
                    <button
                      className="nav-head-out-btn-text"
                      onClick={handlePrevClick}
                    >
                      <span className="nav-head-out-btn-icon">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-left"
                          className="svg-inline--fa fa-arrow-left"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                        >
                          <path
                            fill="currentColor"
                            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 256H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 78.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                          />
                        </svg>
                      </span>
                      {BannerContent?.pesonality_previous_btn}
                    </button>
                  )}

                  {currentTabIndex < tabs.length - 1 ? (
                    <>
                      <button
                        className="nav-head-out-btn-text"
                        onClick={handleNextClick}
                      >
                        {BannerContent?.pesonality_next_btn}

                        <span className="nav-head-out-btn-icon">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="arrow-right"
                            className="svg-inline--fa fa-arrow-right"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path
                              fill="currentColor"
                              d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                            />
                          </svg>
                        </span>
                      </button>

                      {attemptedNextOrSubmit && !isCurrentTabValid() && (
                        <p
                          className="validation-message"
                          style={{ color: "red", marginTop: "10px" }}
                        >
                          Please answer all questions in this tab to continue.
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="nav-head-out-btn1122 combine-btn1122">
                        <button
                          className="nav-head-out-btn-text"
                          onClick={handleSubmit}
                          // disabled={!isAllTabsValid()}
                        >
                          Submit
                          <span className="nav-head-out-btn-icon">
                            <FontAwesomeIcon
                              className="icc"
                              icon={faArrowRight}
                            />
                          </span>
                        </button>

                        {attemptedNextOrSubmit && !isAllTabsValid() && (
                          <p
                            className="validation-message"
                            style={{ color: "red", marginTop: "10px" }}
                          >
                            Please answer all questions in all tabs to submit.
                          </p>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <div className="modal-backdrop deep-save-modal">
          <div className="modal-content">
            <span
              className="email-content-sec"
              dangerouslySetInnerHTML={{
                __html: BannerContent?.personality_email_content,
              }}
            />

            <button
              onClick={() => {
                setShowSuccessModal(false);
                setTimeout(() => {
                    window.location.href = '/cognitive32';
                }, 3000);
              }}
              className="nav-head-out-btn-text"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeepDrive;